module.exports = __webpack_public_path__ + "img/PS-M-13.8601f0d3.svg";